import axios from "axios";

export function axiosGet(url) {
	var headers = { "Content-Type": "application/json" };
	if (localStorage.getItem("token") != null) {
		var token = localStorage.getItem("token");
		headers.Authorization = "Bearer " + token;
	}
	return new Promise(function (myResolve, myReject) {
		axios
			.get(url, { headers: headers })
			.then(function (response) {
				if (response.status == 200) {
					myResolve(response.data);
				} else {
					myResolve(null);
				}
			})
			.catch(function (AxiosError) {
				console.log(AxiosError);
				var error_message = AxiosError.message;
				if (AxiosError.response != undefined) {
					if (AxiosError.response.data != undefined) {
						if (AxiosError.response.data.message != undefined) {
							error_message = AxiosError.response.data.message;
						}
					}
				}
				myResolve({ status: false, error: error_message });
			});
	});
}

export function axiosPost(url, params, multipart) {
	var headers = { "Content-Type": "application/json" };
	if (multipart != undefined) {
		if (multipart == 1) {
			headers = { "Content-Type": "multipart/form-data" };
		}
	}
	if (localStorage.getItem("token") != null) {
		var token = localStorage.getItem("token");
		headers.Authorization = "Bearer " + token;
	}
	return new Promise(function (myResolve, myReject) {
		axios
			.post(url, params, { headers: headers })
			.then(function (response) {
				if (response.status == 200) {
					myResolve(response.data);
				} else {
					myResolve(null);
				}
			})
			.catch(function (AxiosError) {
				myResolve(null);
				console.log(AxiosError);
				var error_message = AxiosError.message;
				if (AxiosError.response != undefined) {
					if (AxiosError.response.data != undefined) {
						if (AxiosError.response.data.message != undefined) {
							error_message = AxiosError.response.data.message;
						}
					}
				}
			});
	});
}

export const formatPriceInUSD = (price) => {
  const formattedPrice = parseFloat(price).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: price % 1 === 0 ? 0 : 2, // Set decimal places based on original price
    maximumFractionDigits: 2 // Maximum fraction digits (cents)
  })
  return formattedPrice
}